module.exports = __webpack_public_path__ + "img/p89.bc107350.png";